import { render, staticRenderFns } from "./PortContactOverlay.vue?vue&type=template&id=60d5df7a&scoped=true"
import script from "./PortContactOverlay.vue?vue&type=script&lang=js"
export * from "./PortContactOverlay.vue?vue&type=script&lang=js"
import style0 from "./PortContactOverlay.vue?vue&type=style&index=0&id=60d5df7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5df7a",
  null
  
)

export default component.exports